import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "state";
import api from "utils/api";
import {
  COOKIE_CONSENT,
  getCookieConsentDecision,
  setAnalyticsCookieConsent,
} from "utils/cookieConsent";
import "styles/cookie-consent.css";

const CookieConsentBanner = () => {
  const user = useSelector((state) => state.user);
  const token = useSelector((state) => state.token);
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setVisible(!getCookieConsentDecision(user));
  }, [user]);

  if (!visible) return null;

  const choose = async (decision) => {
    if (saving) return;
    setSaving(true);
    setError("");
    try {
      if (token && user) {
        const { data } = await api.patch("/auth/cookie-consent", { decision });
        dispatch(setUser({ user: data.user }));
      }
      setAnalyticsCookieConsent(decision);
      setVisible(false);
    } catch {
      setError("Die Einstellung konnte nicht gespeichert werden. Bitte versuche es erneut.");
    } finally {
      setSaving(false);
    }
  };

  return createPortal(
    <section
      className="cookie-consent"
      aria-labelledby="cookie-consent-title"
      role="dialog"
      aria-modal="false"
    >
      <div className="cookie-consent__content">
        <h2 id="cookie-consent-title">Cookies und Analyse</h2>
        <p>
          Notwendiger Speicher hält Buchung und Login funktionsfähig. Google
          Analytics nutzen wir nur mit deiner Zustimmung.
        </p>
        <Link className="cookie-consent__link" to="/datenschutz#cookies">
          Mehr erfahren
        </Link>
        {error && <p className="cookie-consent__error" role="alert">{error}</p>}
      </div>

      <div className="cookie-consent__actions" aria-label="Cookie-Auswahl">
        <button
          type="button"
          className="cookie-consent__button"
          onClick={() => choose(COOKIE_CONSENT.declined)}
          disabled={saving}
        >
          Ablehnen
        </button>
        <button
          type="button"
          className="cookie-consent__button cookie-consent__button--primary"
          onClick={() => choose(COOKIE_CONSENT.accepted)}
          disabled={saving}
        >
          Zustimmen
        </button>
      </div>
    </section>,
    document.body
  );
};

export default CookieConsentBanner;
